import { EventTypes, PageSourceType, track } from '@mc/track-event'

export const trackContestPromoViewed = (pageSource: PageSourceType) =>
  track('Contest Promo Viewed', {
    page_source: pageSource,
  })

export const trackContestLinkClicked = (slug: string) =>
  track(EventTypes.COURSE_MARKETING_CLICK, {
    action: 'Learn More',
    location: 'contest_promo_section',
    slug,
  })
